import styled from "styled-components";
import { palette } from "styled-theme";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 10px;

  h3 {
    color: ${palette("color", 15)};
    padding-top: 10px;
    text-align: center;
  }

  p {
    padding-top: 10px;
    text-align: center;
  }

  .animated-gif-sad {
    max-width: 80px;
  }

  .apply-button {
    margin: 30px 0px 20px;
    width: 200px;
  }
`;
